import CONSTANTS from "../CONSTANTS";
//SweetAlert
export const actionSweetAlert = (sweetAlert) => ({
  type: CONSTANTS.SWEET_ALERT,
  sweetAlert,
});
//Collapse
export const actionSetCollapse = (collapse) => ({
  type: CONSTANTS.COLLAPSE,
  collapse,
});

//Set web socket status
export const actionWsStatus = (status) => ({
  type: CONSTANTS.WS_STATUS,
  status,
});
